var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroCloud2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 127,
    viewBox: "0 0 193 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_1106_437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1649 66.5567C27.8956 65.1958 27.7514 63.7883 27.7514 62.3454C27.7514 50.5147 37.2984 40.925 49.0764 40.925C50.5864 40.925 52.0583 41.0862 53.4785 41.3868C53.4377 40.6517 53.4133 39.9111 53.4133 39.1677C53.4105 17.5369 70.8694 0 92.4067 0C109.46 0 123.945 10.9999 129.243 26.3177C133.394 23.8472 138.237 22.4261 143.412 22.4261C158.792 22.4261 171.259 34.9482 171.259 50.3972C171.259 54.5648 170.345 58.5139 168.718 62.0666C182.705 65.879 193 78.7072 193 93.9512C193 112.19 178.265 127 160.098 127H11.1223C4.27426 120.548 0 111.382 0 101.207C0 84.0991 12.0963 69.8307 28.1649 66.5567Z",
    fill: "url(#paint0_linear_1106_437)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1106_437",
    x1: 96.5,
    y1: 0,
    x2: 96.5,
    y2: 127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B2CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391559",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1106_437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 127,
    fill: "white",
    transform: "matrix(-1 0 0 1 193 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroCloud2);
export default __webpack_public_path__ + "static/media/hero-cloud-2.20dcf1b58a607b7bb7bc68fefd444cb3.svg";
export { ForwardRef as ReactComponent };